import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectDimensionDefaults, updateDefaults } from '../../../../redux/panelDetailSlice';

export default function DimensionSection() {
  const dispatch = useDispatch();
  const dim = useSelector(selectDimensionDefaults);

  const handleChange = (field, value) => {
    const numVal = parseFloat(value);
    if (isNaN(numVal) || numVal < 0) return;
    dispatch(updateDefaults({
      section: 'dimensions',
      changes: { [field]: numVal },
    }));
  };

  const handlePositionChange = (posKey, checked) => {
    dispatch(updateDefaults({
      section: 'dimensions',
      changes: { positions: { [posKey]: checked } },
    }));
  };

  const handleDoorPositionChange = (posKey, checked) => {
    dispatch(updateDefaults({
      section: 'dimensions',
      changes: { doorPositions: { [posKey]: checked } },
    }));
  };

  return (
    <div className="detail-section-content">
      <div className="detail-two-col">
        <div className="detail-col">
          <div className="detail-field">
            <label>Ofset</label>
            <input
              type="number"
              step="1"
              value={dim.offset}
              onChange={e => handleChange('offset', e.target.value)}
            />
          </div>
          <div className="detail-field">
            <label>Line Uzunluk</label>
            <input
              type="number"
              step="1"
              value={dim.lineLength}
              onChange={e => handleChange('lineLength', e.target.value)}
            />
          </div>
          <div className="detail-field">
            <label>Text Size</label>
            <input
              type="number"
              step="1"
              value={dim.textSize}
              onChange={e => handleChange('textSize', e.target.value)}
            />
          </div>
        </div>
        <div className="detail-col">
          <div className="detail-field">
            <label>Arrow Size</label>
            <input
              type="number"
              step="0.5"
              value={dim.arrowSize}
              onChange={e => handleChange('arrowSize', e.target.value)}
            />
          </div>
          <div className="detail-field">
            <label>Precision</label>
            <input
              type="number"
              min="0"
              max="4"
              value={dim.precision}
              onChange={e => handleChange('precision', e.target.value)}
            />
          </div>
        </div>
      </div>

      <hr className="detail-hr" />

      <div className="detail-field">
        <label>Kapaksiz Olcu Konumlari</label>
        <div className="detail-checkbox-row">
          <label>
            <input
              type="checkbox"
              checked={dim.positions.top}
              onChange={e => handlePositionChange('top', e.target.checked)}
            />
            Ust
          </label>
          <label>
            <input
              type="checkbox"
              checked={dim.positions.bottom}
              onChange={e => handlePositionChange('bottom', e.target.checked)}
            />
            Alt
          </label>
          <label>
            <input
              type="checkbox"
              checked={dim.positions.left}
              onChange={e => handlePositionChange('left', e.target.checked)}
            />
            Sol
          </label>
          <label>
            <input
              type="checkbox"
              checked={dim.positions.right}
              onChange={e => handlePositionChange('right', e.target.checked)}
            />
            Sag
          </label>
          <label>
            <input
              type="checkbox"
              checked={dim.positions.internal}
              onChange={e => handlePositionChange('internal', e.target.checked)}
            />
            Ic
          </label>
        </div>
      </div>

      <div className="detail-field">
        <label>Kapakli Olcu Konumlari</label>
        <div className="detail-checkbox-row">
          <label>
            <input
              type="checkbox"
              checked={dim.doorPositions?.top}
              onChange={e => handleDoorPositionChange('top', e.target.checked)}
            />
            Ust
          </label>
          <label>
            <input
              type="checkbox"
              checked={dim.doorPositions?.bottom}
              onChange={e => handleDoorPositionChange('bottom', e.target.checked)}
            />
            Alt
          </label>
          <label>
            <input
              type="checkbox"
              checked={dim.doorPositions?.left}
              onChange={e => handleDoorPositionChange('left', e.target.checked)}
            />
            Sol
          </label>
          <label>
            <input
              type="checkbox"
              checked={dim.doorPositions?.right}
              onChange={e => handleDoorPositionChange('right', e.target.checked)}
            />
            Sag
          </label>
        </div>
      </div>
    </div>
  );
}
